var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartBackClass"},[_c('div',{ref:_vm.refName,style:({ width: _vm.width, height: _vm.height }),attrs:{"id":"barchartDom"}}),(!_vm.showBool)?_c('div',{staticClass:"noDataBackClass"},[_c('div',{staticClass:"noDataView"},[_vm._v("暂无数据，敬请期待")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }